import React from "react";

// styles
import { DividerStyled } from "./styles.js";

export const Divider = () => {
    return <DividerStyled />;
};
